<template>
  <div class="bg-gray-800 text-white">
    <div class="container mx-auto px-4 flex justify-between">
      <div class="flex justify-between flex-grow">
        <div class="flex m-2">
          <!-- <img class="h-8 m-4 " src="../assets/logo.png"/> -->
          <router-link to="/">
            <img height="24" width="24" src="/code.png" alt="" />
          </router-link>
        </div>

        <ul class="flex">
          <!-- <router-link to="css"><li class="p-2">#CSS</li></router-link> -->
          <!-- <router-link to="js"><li class="p-2">#JS</li> </router-link> -->
          <router-link to="website"><li class="p-2">#Projects</li></router-link>
        </ul>
      </div>
      <ul class="flex">
        <li class="p-2">
          <a href="https://learning-portfolio.jin-teng.uk/" target="_blank">
            #Portfolio
          </a>
        </li>
        <li class="p-2">
          <a href="https://www.instagram.com/jt.9924/" target="_blank">
            <img width="24px" height="24px" src="../assets/icon-ig.png" />
          </a>
        </li>
        <li class="p-2">
          <a
            href="https://www.linkedin.com/in/li-jinteng/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img width="24px" height="24px" src="../assets/icon-li.png" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h-60px {
  height: 60px;
}
</style>
